// DEV
// export default 'https://dev-ordertracking.goshowfa.com'

// PRD
export default 'https://ordertracking.goshowfa.com'